import React, { useState } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { Select, Button, Modal, message, Tooltip, Icon, Spin, Table } from 'antd';
import { Grid } from '@material-ui/core';
import TextEvents from '../TextEvents';
import TextInput from 'app/components/TextInput';
import { styles, useStyles } from './ACCPBossFormStyles';
import ACCPBossTableContainer from 'app/containers/ACCPBossTableContainer';
import { fetchACCPBoss, fetchACCPBossAvailable, accpBossClear, fetchACCPBossFilter, accpBossFilterClear, accpBossAvailableClear } from 'app/actions/ACCPBossActions';
import ApiService from 'app/services/ApiService';

const { confirm } = Modal;
const { Option } = Select;
const SelectItem = (name = [], value) => {
    let x = name[value]
    return typeof x !== 'undefined' && x !== null ? x.map((c, i) => <Option key={i}>{c}</Option>) : (x === null ? <Option key={'cargando'}>No existen valores..</Option> : <Option disabled key={'cargando'}>Cargando valores..</Option>);

}

export default function ACCPBossForm(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [name, setName] = useState([]); 
    const [employeeId, setEmployeeId] = useState([]); 
    const [collapse, setCollapse] = useState(true);
    const [rowSelection, setRowSelection] = useState({
        idResponsible: [],
        onChange: onSelectChange,
    });
    const {siteId} = useSelector(state => state.Auth)

    function onSelectChange(selectedRowKeys) {
        setRowSelection({ ...rowSelection, idResponsible: selectedRowKeys });
    };  
    const data = {
        employee: props.FiltroNombre.join('|'),
        sortColumn: Object.keys(props.sorter).length > 0 ? props.sorter.field : '',
        sortDir: Object.keys(props.sorter).length > 0 ? props.sorter.order === "ascend" ? "ASC" : "DESC" : '',
        offset: (0 * props.pagination.pageSize),
        limit: props.pagination.pageSize
    }

    const handleChange = (value, i, key) => {
        const array = [];
        i.map(i => {
            array.push(i.props.children);
            return array;
        })
        if (i.length === 0) {
            switch (key) {
                case 'employeeName':
                    setName([])
                    props.setFiltroNombre([]);
                    break;
                case 'employeeId':
                    setEmployeeId([])
                    break;
                default:
                    break;
            }
        }
        // eslint-disable-next-line array-callback-return
        i.map(() => {
            if (key === 'employeeName') {
                setName([array])
                props.setFiltroNombre(array);
            }
            else if (key === 'employeeId') {
                setEmployeeId([array])
            }
        });
    }


    const submit = () => {
        ApiService.setEmployeeBoss({ boss: true, listEmployeeId: rowSelection.idResponsible }, 'PUT').then(
            res => {
                props.isVisibleForm(false)
                message.success(`Jefe(es) de AC y CP guardadados correctamente!`);
                dispatch(accpBossFilterClear());
                dispatch(fetchACCPBossFilter());
                dispatch(accpBossAvailableClear());
                search();
                setRowSelection({ ...rowSelection, idResponsible: [] })
            },
            error => {
                message.error('Ocurrió un error intente mas tarde.');
            }
        );
    }
    const search = () => {
        dispatch(accpBossClear());
        dispatch(fetchACCPBoss(data));
        dispatch(fetchACCPBossAvailable());
        props.setFormData(data);
    }

    const newBoss= () => {
        setRowSelection({ ...rowSelection, idResponsible: [] });
        props.isVisibleForm(true);
    }

    const toExport = async () => {
        await ApiService.exportEmployeeBoos(data)
            .then(
                result => {
                    const blob = new Blob([result], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                    downloadFile(blob, "BandejaJefeACyCP.xlsx");
                },
                error => {
                    throw ({ error: error, message: 'An error ocurred' });
                }
            )
    }

    const downloadFile = (blob, fileName) => {
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        document.body.append(link);
        link.click();
        link.remove();
        window.addEventListener('focus', e => URL.revokeObjectURL(link.href), { once: true });
    };

    return (
        <div>
            <ACCPBossTableContainer>
                {(params) => {
                    return (
                        <div>
                            <div hidden={collapse}>
                                <Grid container direction="row">
                                    <Grid item xs={6}>
                                        <TextEvents
                                            text='Nombre:'
                                            color="darker"
                                            size='label'
                                            weight="medium"
                                        />
                                        <Select
                                            mode="multiple"
                                            showSearch
                                            value={props.FiltroNombre}
                                            optionFilterProp="children"
                                            style={{ ...styles.fullWidth, ...styles.smallBottomMargin }}
                                            placeholder="Selecciona nombre"
                                            onChange={(v, i) => handleChange(v, i, 'employeeName')}
                                            >
                                            {SelectItem(params.accpBossFilter[0], 'name')}
                                        </Select>
                                    </Grid>
                                </Grid>
                            </div>
                            <div className={classes.container} style={styles.baseVerticalMargin}>
                            {
                                    collapse ?
                                        <Tooltip title={"Mostrar filtro"}>
                                        <Button
                                            className={classes.button}
                                            variant="contained"
                                            type="link"
                                            onClick={() => setCollapse(false)}
                                        >
                                            <Icon type="down" />
                                        </Button>
                                        </Tooltip> :
                                        <Tooltip title={"Ocultar filtro"}>
                                        <Button
                                            className={classes.button}
                                            variant="contained"
                                            type="link"
                                            onClick={() => setCollapse(true)}
                                        >
                                            <Icon type="up" />
                                        </Button>
                                        </Tooltip>
                                }
                                <Button
                                    className={classes.button}
                                    variant="contained"
                                    type="primary"
                                    onClick={() => search()}
                                >
                                    Buscar
                                 </Button>
                                <Button
                                    className={classes.button}
                                    variant="contained"
                                    type="primary"
                                    onClick={toExport}
                                >
                                    Exportar
                                </Button>
                                {
                                    siteId === "HUB"?
                                    <Button
                                        className={classes.button}
                                        variant="contained"
                                        type="primary"
                                        onClick={newBoss}
                                    >
                                        Nuevo
                                    </Button>:null
                                }
                            </div>
                        </div>
                    )
             }}
            </ACCPBossTableContainer>
            <Modal
                destroyOnClose={true}
                onCancel={() => props.isVisibleForm(false)}
                visible={props.visibleForm}
                title={<TextEvents
                    text={'Nuevo Jefe(es) de AC y CP'}
                    color='cotemar'
                    size='label'
                    weight='bold'
                />}
                width={'650px'}
                centered={true}
                footer={[
                    <Button key="back" type="danger" ghost onClick={() => props.isVisibleForm(false)}>
                        Cancelar
                    </Button>,
                    <Button disabled={rowSelection.idResponsible.length === 0} key="submit" type="primary" loading={false} onClick={() => submit()}>
                        Confirmar
                    </Button>,
                ]}
            >
                <Grid container direction="row">
                    <Grid item xs={12} >
                        <TextEvents
                            text='Empleados Disponibles:'
                            color='darker'
                            size='label'
                            weight='medium'
                        />
                        <span>
                            {rowSelection.idResponsible.length > 0 ? `Seleccionados ${rowSelection.idResponsible.length} Registros` : ''}
                        </span>
                        <ACCPBossTableContainer>
                            {(params) => {
                                return (
                                    <Table
                                        rowSelection={rowSelection}
                                        columns={params.columnsNews}
                                        loading={params.isLoadingAvailable}
                                        dataSource={params.accpBossAvailable} />
                                )
                            }}
                        </ACCPBossTableContainer>

                    </Grid>
                </Grid>
            </Modal>
        </div>       
            );
}